import shark from "../../../../apis/shark";
import {
  createEntity,
  createEntityActions,
  createEntityReducer,
} from "../../../../common/entity";

const api = {
  getMany: () => {
    return shark
      .post({ command: "getGroupByPrograms" }, { config: { timeout: 0 } })
      .then((r) => {
        return { data: r.responseData.programs };
      });
  },
};

const entity = createEntity({
  name: "program",
  type: "users/groups/programs",
  getState: (state) => state.users.groups.programs,
});
const actions = createEntityActions({ entity, api });
const reducer = createEntityReducer({
  entity,
  actions,
  persist: true,
});

const programState = {
  api,
  entity,
  actions,
  reducer,
};

export default programState;
